import { createContext, useContext, useState, useEffect } from "react";

interface Location {
  id: number;
  name: string;
  isSelected: boolean;
  isVisible: boolean;
  isDisabled: boolean;
}

interface LocationsMenuContextType {
  unityLocations: Location[];
  handleSelectLocation: (id: number) => void;
  toggleVisibility: (id: number) => void;
}

const LocationsMenuContext = createContext<LocationsMenuContextType | null>(null);

export const LocationsMenuProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const unityLocationsInit: Location[] = [
    { id: 1002, name: "Plant Demo", isSelected: true, isVisible: true, isDisabled: false },
    { id: 1003, name: "Building Demo", isSelected: false, isVisible: true, isDisabled: false },
    { id: 2, name: "Construction Site", isSelected: false, isVisible: true, isDisabled: true },
    { id: 1004, name: "Power Lines", isSelected: false, isVisible: true, isDisabled: false },
    { id: 6, name: "Quarry", isSelected: false, isVisible: true, isDisabled: true },
    { id: 27, name: "Box Demo", isSelected: false, isVisible: true, isDisabled: true },
  ];

  const [unityLocations, setUnityLocations] = useState<Location[]>(unityLocationsInit);

  const handleSelectLocation = (id: number) => {
    setUnityLocations((prevLocations) =>
      prevLocations.map((location) =>
        location.id === id
          ? { ...location, isSelected: true }
          : { ...location, isSelected: false }
      )
    );
  };

  const toggleVisibility = (id: number) => {
    setUnityLocations((prevLocations) =>
      prevLocations.map((location) =>
        location.id === id ? { ...location, isVisible: !location.isVisible } : location
      )
    );
  };

  return (
    <LocationsMenuContext.Provider
      value={{ unityLocations, handleSelectLocation, toggleVisibility }}
    >
      {children}
    </LocationsMenuContext.Provider>
  );
};

export const useLocationsMenu = () => {
  const context = useContext(LocationsMenuContext);
  if (!context) {
    throw new Error("useLocationsMenu must be used within a LocationsMenuProvider");
  }
  return context;
};
